import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    st0: {
      fill: 'none',
      stroke: '#0a6eb4',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,2.978',
    },
    st1: { fill: 'none', stroke: '#0a6eb4', strokeLinecap: 'round', strokeLinejoin: 'round' },
    st2: { fill: 'none', stroke: '#00ADD8', strokeWidth: '14.07' },
    st3: { fill: '#034EA2' },
    st4: { fill: '#FFFFFF' },
    st5: { fontWeight: 'bold' },
    st6: { fontSize: '10px' },
    st7: { fontSize: '9.9997px' },
    st8: { fontSize: '9.9996px' },
    st9: { fontSize: '10.0004px' },
    st10: { fontSize: '20px' },
    st11: { fontSize: '10.0001px' },
    animation: {
      animationName: '$title',
      animationDuration: '1s',
    },
    '@keyframes title': {
      ...animationFunc(),
    },
  }),
);

function animationFunc() {
  return {
    '0%': { opacity: 0 },
    '20%': { opacity: 0 },
    '40%': { opacity: 0.3 },
    '60%': { opacity: 0.5 },
    '80%': { opacity: 0.9 },
    '100%': { opacity: 1 },
  };
}

const EcContributions = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 479.89 163.28" ref={ref}>
      <g>
        <line className={classes.st0} x1="158.36" y1="19.26" x2="158.36" y2="148.78" />
        <g>
          <path
            className={classes.st1}
            d="M158.36,150.27L158.36,150.27 M158.36,16.28L158.36,16.28"
          />
        </g>
        <line className={classes.st0} x1="323.98" y1="19.26" x2="323.98" y2="148.78" />
        <g>
          <path
            className={classes.st1}
            d="M323.98,150.27L323.98,150.27 M323.98,16.28L323.98,16.28"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M104.06,137.12c4.35-2.2,8.4-4.91,12.07-8.03"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M35.5,128.43c10.81,9.52,25.07,15.31,40.69,15.31c7.97,0,15.58-1.51,22.57-4.25"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M98.77,139.49c1.81-0.71,3.58-1.5,5.3-2.37"
          />
          <path
            className={classes.st3}
            d="M76.2,125.37c23.25,0,42.09-18.85,42.09-42.09c0-23.25-18.85-42.1-42.09-42.1s-42.09,18.85-42.09,42.1
                C34.1,106.53,52.95,125.37,76.2,125.37"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M116.13,129.08c13.01-11.09,21.25-27.5,21.25-45.81c0-33.39-27.39-60.46-61.18-60.46S15.02,49.88,15.02,83.27
                c0,17.95,7.92,34.08,20.49,45.15"
          />
        </g>
        <text
          transform="matrix(0.9722 -0.2341 0.2341 0.9722 59.5513 29.3923)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          €
        </text>
        <text
          transform="matrix(0.9871 -0.1599 0.1599 0.9871 64.9227 28.1615)"
          className={clsx(classes.st4, classes.st5, classes.st7)}
        >
          {' '}
        </text>
        <text
          transform="matrix(0.9939 -0.1103 0.1103 0.9939 67.2928 27.7408)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          3
        </text>
        <text
          transform="matrix(0.9999 -0.0113 0.0113 0.9999 72.5928 27.1461)"
          className={clsx(classes.st4, classes.st5, classes.st8)}
        >
          4
        </text>
        <text
          transform="matrix(0.9981 0.0623 -0.0623 0.9981 78.0196 27.0795)"
          className={clsx(classes.st4, classes.st5, classes.st9)}
        >
          2
        </text>
        <text
          transform="matrix(0.9909 0.1348 -0.1348 0.9909 83.4345 27.4694)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          {' '}
        </text>
        <text
          transform="matrix(0.9785 0.2061 -0.2061 0.9785 84.972 27.5055)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          M
        </text>
        <text
          transform="matrix(1 0 0 1 53.3646 90.9254)"
          className={clsx(classes.st4, classes.st5, classes.st10)}
        >
          2017
        </text>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M365.25,128.43c10.81,9.52,25.07,15.31,40.69,15.31c7.97,0,15.59-1.51,22.57-4.25"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M433.81,137.12c9.49-4.81,17.55-12,23.36-20.77"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M428.51,139.49c1.81-0.71,3.58-1.5,5.3-2.37"
          />
          <path
            className={classes.st3}
            d="M405.95,125.37c23.25,0,42.09-18.85,42.09-42.09c0-23.25-18.85-42.1-42.09-42.1s-42.09,18.85-42.09,42.1
                C363.85,106.53,382.7,125.37,405.95,125.37"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 382.8812 90.9254)"
          className={clsx(classes.st4, classes.st5, classes.st10)}
        >
          2019
        </text>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M457.17,116.35c6.3-9.5,9.96-20.86,9.96-33.07c0-33.39-27.39-60.46-61.18-60.46s-61.18,27.07-61.18,60.46
                c0,17.95,7.92,34.08,20.49,45.15"
          />
        </g>
        <text
          transform="matrix(0.9701 -0.2426 0.2426 0.9701 390.211 28.9116)"
          className={clsx(classes.st4, classes.st5, classes.st11)}
        >
          €
        </text>
        <text
          transform="matrix(0.9857 -0.1686 0.1686 0.9857 395.5712 27.6345)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          {' '}
        </text>
        <g>
          <text
            transform="matrix(0.9929 -0.119 0.119 0.9929 397.9379 27.193)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            6
          </text>
          <text
            transform="matrix(0.9998 -0.02 0.02 0.9998 403.2318 26.5523)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            1
          </text>
          <text
            transform="matrix(0.9986 0.0536 -0.0536 0.9986 408.6586 26.4364)"
            className={clsx(classes.st4, classes.st5, classes.st9)}
          >
            3
          </text>
          <text
            transform="matrix(0.9948 0.1021 -0.1021 0.9948 414.1664 26.8101)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            {' '}
          </text>
          <text
            transform="matrix(0.9803 0.1976 -0.1976 0.9803 415.2222 26.7234)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            M
          </text>
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M297.45,108.51c3.57-7.68,5.57-16.23,5.57-25.24c0-1.43-0.05-2.86-0.15-4.27"
          />
          <path
            className={classes.st3}
            d="M241.84,125.37c23.25,0,42.09-18.85,42.09-42.09c0-23.25-18.85-42.1-42.09-42.1s-42.09,18.85-42.09,42.1
                C199.74,106.53,218.59,125.37,241.84,125.37"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M269.7,137.12c4.35-2.2,8.4-4.91,12.07-8.03"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M201.14,128.43c10.81,9.52,25.07,15.31,40.69,15.31c3.67,0,7.26-0.32,10.75-0.93"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M264.4,139.49c1.81-0.71,3.58-1.5,5.3-2.37"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M281.77,129.08c6.61-5.63,11.99-12.64,15.68-20.57"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M252.58,142.81c4.1-0.72,8.05-1.84,11.82-3.32"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 219.0043 90.9254)"
          className={clsx(classes.st4, classes.st5, classes.st10)}
        >
          2018
        </text>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M282.44,38.05c-10.8-9.47-25.02-15.23-40.6-15.23c-28.07,0-51.73,18.68-58.93,44.15"
          />
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M182.9,66.97c-1.47,5.19-2.25,10.66-2.25,16.31c0,17.95,7.92,34.08,20.49,45.15"
          />
        </g>
        <text
          transform="matrix(0.9728 -0.2318 0.2318 0.9728 224.5177 29.1814)"
          className={clsx(classes.st4, classes.st5, classes.st9)}
        >
          €
        </text>
        <text
          transform="matrix(0.9836 -0.1803 0.1803 0.9836 229.9779 27.944)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          {' '}
        </text>
        <g>
          <text
            transform="matrix(0.9948 -0.1016 0.1016 0.9948 232.2284 27.4771)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            9
          </text>
          <text
            transform="matrix(0.9998 -0.022 0.022 0.9998 237.6037 26.903)"
            className={clsx(classes.st4, classes.st5, classes.st9)}
          >
            3
          </text>
          <text
            transform="matrix(0.9985 0.0552 -0.0552 0.9985 243.016 26.7877)"
            className={clsx(classes.st4, classes.st5, classes.st6)}
          >
            6
          </text>
        </g>
        <text
          transform="matrix(0.9944 0.1061 -0.1061 0.9944 248.515 27.1673)"
          className={clsx(classes.st4, classes.st5, classes.st9)}
        >
          {' '}
        </text>
        <text
          transform="matrix(0.9834 0.1815 -0.1815 0.9834 249.6306 27.1783)"
          className={clsx(classes.st4, classes.st5, classes.st6)}
        >
          M
        </text>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st2)}
            d="M302.87,79.01c-1.15-16.27-8.81-30.77-20.43-40.96"
          />
        </g>
      </g>
    </svg>
  );
};

export default EcContributions;
